<template>
  <base-entities-list
    tag="settings"
    :cardComponent="entityComponent"
    :innerTableHeaders="innerHeaders"
    :enrichFunc="enrichSettings"
    :isHideSites="true"
  ></base-entities-list>
</template>

<script>
import BaseEntitiesList from '../BaseEntitiesList';
import SiteSettingsCard from './SiteSettingsCard';

export default {
  components: {
    BaseEntitiesList
  },

  created() {
    // Загружаем все данные по связанным сущностям
    this.$store.dispatch('sites/loadEntitiesList', {tag: 'specialist'});
    this.$store.dispatch('sites/loadEntitiesList', {tag: 'testimonial'});
    this.$store.dispatch('sites/loadEntitiesList', {tag: 'portfolio'});
    this.$store.dispatch('prices/loadList');
    this.$store.dispatch('users/loadList');
  },

  methods: {
    enrichSettings(elem) {
      elem.partnerName = this.$store.getters['users/partnerUsers'].find(x => x._id == elem.partner).fullName;
      elem.statusText = elem.isActive ? 'Активно' : 'Черновик';
    },
  },

  data() {
    return {
      entityComponent: SiteSettingsCard,
      innerHeaders: [
        {
          text: 'Партнер',
          value: 'partnerName'
        },
        {
          text: 'Статус',
          value: 'statusText'
        }
      ],
    }
  }
}
</script>